var code  // 在全局 定义验证码
var code2 // 在全局 定义验证码
const createCode = function (codeId, codeVal) {
  if (codeVal) {
    if (codeVal != code2) {
      return false
    } else {
      return true
    }
  } else {
    code = ''
    var checkCode = document.getElementById(codeId)
    function RndNum (n) {
      var rnd = ''
      for (var i = 0; i < n; i++) { rnd += Math.floor(Math.random() * 10) }
      return rnd
    }
    var num = RndNum(2)
    var num2 = RndNum(2)
    code = num + '+' + num2 + '='
    code2 = parseInt(num) + parseInt(num2)
    if (checkCode) {
      checkCode.className = 'code'
      checkCode.value = code
    }
  }
}
export default createCode



// WEBPACK FOOTER //
// ./src/api/checkCode.js